export class NoMatrixAccount extends Error {
    constructor(message: string) {
        super()
        this.message = message
    }
}
